import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/reports`;

export const reportsApi = {
  doctypes: () => axios.get(`${BASE}/meta/doctypes`),
  fields: (doctype) => axios.get(`${BASE}/meta/fields/${doctype}`),
  run: (query) => axios.post(`${BASE}/run`, query),
  list: (params = {}) => axios.get(BASE, { params }),
  get: (id) => axios.get(`${BASE}/${id}`),
  create: (payload) => axios.post(BASE, payload),
  update: (id, payload) => axios.put(`${BASE}/${id}`, payload),
  remove: (id) => axios.delete(`${BASE}/${id}`),
  runSaved: (id) => axios.post(`${BASE}/${id}/run`),
};

export default reportsApi;
